<template>
  <div class="english-container">
    <h2>1. Premiers pas</h2>
    <p style="text-align: left;">Afin d’éviter les arrêts accidentels qui pourraient empêcher l’appareil de se localiser, nous avons amélioré les méthodes de démarrage et d’arrêt.</p>

    <h4>1.1 Allumer/Éteindre</h4>
    <p style="text-align: left;">1.1.1 Allumer : Maintenez le bouton d'alimentation circulaire pendant 3 secondes. Lorsque vous entendez un double son de notification, cela signifie que l'appareil est allumé. (Voir schéma)</p>

    <img src="../assets/gid_1.png" alt="Wireless Tag Logo" class="image_1" />

    <p style="text-align: left;">
      1.1.2 Éteindre : Appuyez deux fois sur le bouton de l’appareil, vous entendrez un signal sonore de confirmation. Ensuite, maintenez le bouton d’alimentation pendant 3 secondes (si vous le relâchez avant ou après 3 secondes, l’appareil ne s’éteindra pas). <strong>Relâchez-le ensuite...</strong>, vous entendrez deux bips indiquant qu’il est éteint.
    </p>
    <p style="text-align: left;">
      <strong>Remarque : la fonction de temporisation à l’extinction est conçue pour éviter les arrêts accidentels et permettre à l’appareil de continuer à localiser efficacement.</strong>
    </p>

    <h4>1.2 Vérifier les mises à jour</h4>
    <p style="text-align: left;">
      Pour utiliser l'application Apple® Find My® afin de localiser votre appareil, il est recommandé d'utiliser la dernière version d'iOS®, iPadOS® ou macOS®. L'application Find My sur Apple Watch nécessite la dernière version de watchOS®.
    </p>

    <h3>2. Ajouter votre Localisateur</h3>
    <h4>2.1 Démarrer l'application</h4>
    <p style="text-align: left;">2.1.1 Ouvrez l’application Find My sur votre iPhone® ou iPad® compatible.</p>
    <p style="text-align: left;">2.1.2 Autorisez les notifications provenant de l’application.</p>

    <h4>2.2 Connecter votre Localisateur</h4>
    <p style="text-align: left;">2.2.1 Allumez votre Localisateur, sélectionnez l’onglet « Objets », puis appuyez sur l’onglet « Ajouter un objet » et choisissez <strong>« Autres objets compatibles »</strong>.</p>
    <p style="text-align: left;">2.2.2 Assurez-vous que votre Localisateur est proche de votre téléphone. Attendez… jusqu’à ce que vous voyiez apparaître la fenêtre pop-up « Étiquette sans fil », puis touchez « Se connecter ».</p>
    <p style="text-align: left;">2.2.3 Choisissez un nom reconnaissable et un emoji pour votre Localisateur, puis appuyez sur « Continuer ».</p>
    <p style="text-align: left;">2.2.4 L’application Find My vous demandera de confirmer l’ajout de votre Localisateur à votre compte Apple ID – appuyez sur « Continuer ».</p>
    <p style="text-align: left;">2.2.5 Appuyez sur « Terminer ». Votre Localisateur est configuré et prêt à être associé à n’importe quel objet que vous souhaitez localiser, par exemple vos clés.</p>

    <h3>3. Présentation des fonctions</h3>

    <h4>3.1 Localiser votre objet</h4>
    <p style="text-align: left;">Lorsque votre objet est à proximité, appuyez sur « Jouer le son » pour faire sonner votre Localisateur, vous pourrez ainsi le retrouver. S’il est hors de portée, vous pouvez consulter sa dernière position connue.</p>

    <h4>3.2 Notifications</h4>
    <p style="text-align: left;">Vous recevrez une notification lorsque vous laisserez votre Localisateur derrière vous alors qu’il sort de la portée de votre appareil.</p>
    <p style="text-align: left;"><strong>Note :</strong> « Notifier quand trouvé » ne peut être activé que lorsque votre Localisateur est hors de portée.</p>

    <h4>3.3 Partager des objets</h4>
    <p style="text-align: left;">Les personnes avec qui vous avez partagé l’objet pourront le localiser, mais elles ne recevront pas de notifications liées à un suivi non identifié.</p>
    <p style="text-align: left;">Pour utiliser la fonctionnalité de partage, assurez-vous que vous et vos amis utilisez les versions publiques beta d’iOS 17, iPadOS 17 ou macOS 14 Sonoma, ou une version plus récente.</p>

    <h4>3.4 Mode Perdu</h4>
    <p style="text-align: left;">Lorsque votre objet est perdu, activez le mode Perdu, vous recevrez une notification dès qu’une localisation sera disponible. Vous pouvez laisser un numéro de téléphone ou une adresse e-mail pour que la personne qui retrouve l’objet puisse vous contacter.</p>
    <p style="text-align: left;"><strong>Note :</strong> Lorsque le « Mode Perdu » est activé, votre Localisateur est verrouillé et personne d’autre ne peut s’y connecter. NE PAS SUPPRIMER L’OBJET dans l’application. Votre Localisateur restera verrouillé et ne pourra être utilisé par personne.</p>

    <h4>3.5 Supprimer un objet</h4>
    <p style="text-align: left;">Assurez-vous que l’objet est à proximité, vous pouvez supprimer l’objet via l’application. Un bip retentira pour indiquer que la suppression a réussi, l’objet pourra alors être utilisé par d’autres personnes.</p>
    <p style="text-align: left;"><strong>Note :</strong> Si le « Mode Perdu » est activé, NE PAS SUPPRIMER L’OBJET dans l’application, sinon votre Localisateur sera verrouillé et personne ne pourra s’y connecter.</p>

    <h4>3.6 Réinitialisation d’usine de votre Localisateur</h4>
    <p style="text-align: left;">Lorsque votre objet est hors de portée de votre téléphone et que votre Localisateur a été supprimé de l’application Find My, il ne peut plus être utilisé par d’autres personnes. Vous devez réinitialiser votre Localisateur pour qu’il puisse être utilisé à nouveau.</p>
    <p style="text-align: left;">Procédure de réinitialisation d’usine : Appuyez deux fois sur le bouton fonctionnel, vous entendrez un bip. Appuyez ensuite quatre fois rapidement sur le bouton fonctionnel, puis maintenez-le lors de la cinquième pression jusqu’à entendre un double son. L’appareil est maintenant réinitialisé. Il peut être ajouté à un nouveau compte Apple ID comme un nouvel appareil.</p>

    <h4>3.7 Détection de suivi non désiré</h4>
    <p style="text-align: left;">Si un accessoire réseau Find My séparé de son propriétaire semble bouger avec vous au fil du temps, vous serez notifié de l’une des deux manières suivantes : (1) Si vous possédez un iPhone ou un iPad, Find My enverra une notification à votre appareil Apple. Cette fonctionnalité est disponible sous iOS ou iPadOS 14.5 ou ultérieur. (2) Si vous ne possédez pas d’appareil iOS ou de smartphone, un accessoire réseau Find My qui n’est pas avec son propriétaire depuis un certain temps émettra un son lorsqu’il sera déplacé.</p>
    <p style="text-align: left;">Ces fonctionnalités ont été spécialement conçues pour dissuader toute tentative de suivi sans votre consentement.</p>

    <h3>4. Spécifications</h3>
    <ul>
      <li>Pile : CR2032 3 V (remplaçable)</li>
      <li>Tension de fonctionnement : 2,8 V - 3,3 V</li>
      <li>Capacité : 220 mAh</li>
      <li>Portée sans fil : 10 à 30 mètres</li>
      <li>Sirène : Max 100 dB</li>
      <li>Dimensions : φ32 x 7,9 mm</li>
    </ul>

    <h3>5. Fonction des boutons</h3>
    <ol>
      <li style="text-align: left;">
        <strong>Allumer (la fonction Find My est active).</strong>
        <p>Appuyez sur le bouton fonction pendant 3 secondes pour l’allumer. Vous entendrez un double son indiquant qu’il est allumé.</p>
        <p>Si le produit n’est pas lié à votre compte Apple ID, il s’éteindra automatiquement au bout de 10 minutes. Vous devrez activer à nouveau la fonction Find My pour poursuivre l’appairage.</p>
      </li>
      <li style="text-align: left;">
        <strong>Éteindre (la fonction Find My est inactive).</strong>
        <p>Maintenez le bouton fonction pendant trois secondes, puis relâchez-le. Vous entendrez deux bips indiquant qu’il est éteint.</p>
      </li>
      <li style="text-align: left;">
        <strong>Activer la requête d’informations supplémentaires.</strong>
        <p>Appuyez deux fois rapidement sur le bouton fonction et vous entendrez un signal de confirmation. Cette action sera affichée dans l’application Find My pour guider la personne qui récupère l’appareil à obtenir des informations telles que les coordonnées du propriétaire (si l’objet est en mode Perdu), ainsi que le numéro de série de l’appareil.</p>
      </li>
      <li style="text-align: left;">
        <strong>Réinitialiser aux paramètres d’usine</strong>
        <p>Appuyez deux fois sur le bouton fonction, vous entendrez un bip. Appuyez ensuite quatre fois rapidement sur le bouton fonction, puis maintenez-le lors de la cinquième pression jusqu’à entendre un double son. L’appareil est maintenant réinitialisé.</p>
        <p>Une réinitialisation est nécessaire pour que l’appareil entre en mode appairage.</p>
      </li>
    </ol>

    <h3>6. Remplacement de la batterie et du cordon</h3>
    <ol>
      <li>Insérez l’outil d’ouverture dans la fente du boîtier.</li>
      <li>Faites tourner l’outil d’ouverture de 90 degrés pour ouvrir le boîtier.</li>
      <li>Utilisez vos ongles pour trouver l’ouverture latérale du Localisateur d’Objet, et ouvrez délicatement le boîtier.</li>
      <li>Remplacez la batterie par une nouvelle batterie CR2032 3 V. (Pôle positif avec le texte vers le haut).</li>
    </ol>

    <img src="../assets/open_tag.png" alt="Wireless Tag Logo" class="image_1" />
    <img src="../assets/open_tag_2.png" alt="Wireless Tag Logo" class="image_1" />

    <h3>FAQ</h3>
    <h4>1. Pourquoi la localisation de mon appareil ne se met-elle pas à jour ?</h4>
    <li style="text-align: left;">Il y a deux principes pour la transmission de la position. Si plusieurs appareils Apple sont à proximité, chaque utilisateur proche transmettra sa position environ toutes les 2 à 5 minutes. Si l’appareil n’a pas bougé, ses capteurs intégrés le détecteront et il passera en veille. La position signalée peut varier entre 30 minutes et plusieurs heures. Ne vous inquiétez pas, la position que vous voyez peut être vieille de 30 minutes ou plusieurs heures, mais il est très probable que l’objet n’ait pas bougé et que la position affichée soit la dernière connue.</li>

    <h4>2. Lors de l’appairage avec l’application Find My, le téléphone se connecte au serveur Apple. L’appairage peut échouer à cause de problèmes réseau. Les actions suivantes sont recommandées :</h4>
    <ol>
      <li style="text-align: left;">Changez le réseau du téléphone, par exemple passez du Wi-Fi au mobile. Le premier appairage peut prendre beaucoup de temps, veuillez patienter.</li>
      <li style="text-align: left;">Réinitialisez votre appareil.</li>
      <li style="text-align: left;">Réparez avec l’application Find My.</li>
    </ol>

    <h3>Vie privée et sécurité</h3>
    <p style="text-align: left; color:#333;">Votre Localisateur émet un signal Bluetooth sécurisé détectable par les appareils proches appartenant au réseau Find My. Ces appareils transmettent la position de votre Localisateur à iCloud — vous pouvez ensuite consulter cette position via l’application Find My sur une carte. L’ensemble du processus est anonyme et chiffré pour protéger votre vie privée.</p>

    <h3>AVERTISSEMENT</h3>
    <ol>
      <li>Retirez immédiatement les piles usagées et recyclez-les conformément aux réglementations locales. Tenez-les hors de portée des enfants. NE JETEZ PAS les piles dans les ordures ménagères ni ne les brûlez.</li>
      <li>Même les piles usagées peuvent provoquer des blessures graves voire mortelles.</li>
      <li>Contactez un centre antipoison local pour obtenir des informations sur les traitements.</li>
      <li>Les piles non rechargeables ne doivent pas être rechargées.</li>
      <li>Ne forcez pas la décharge, ne rechargez pas, ne démontez pas, ne chauffez pas au-delà de 50 °C / 122 °F, ni ne brûlez.</li>
      <li>Cela pourrait entraîner des blessures dues à l’émission de gaz, des fuites ou explosions causant des brûlures chimiques.</li>
      <li>Le type de pile compatible est : CR2032.</li>
      <li>Tension nominale de la pile : CC 3 V.</li>
      <li>Assurez-vous que les piles sont installées correctement selon la polarité (+ et -).</li>
      <li>Évitez de mélanger des piles neuves et anciennes, de marques ou types différents (alcalines, zinc-carbone, ou rechargeables).</li>
      <li>Retirez immédiatement les piles des appareils inutilisés depuis longtemps et recyclez-les conformément aux réglementations locales.</li>
      <li>Veillez toujours à bien fermer le compartiment des piles. Si le couvercle ne se ferme pas correctement, arrêtez d’utiliser le produit, retirez les piles et gardez-les hors de portée des enfants.</li>
    </ol>

    <h5>
      <p>Type de batterie : CR2032. Tension de la batterie : 3 V.</p>
      <p>Gardez-la dans son emballage d’origine jusqu’à ce que vous soyez prêt à l’utiliser.</p>
      <p>Jetez immédiatement les batteries usagées et tenez-les éloignées des enfants. NE JETEZ PAS les batteries dans les ordures ménagères.</p>
    </h5>

    <img src="../assets/image_battery.png" class="image_1" />
  </div>
</template>

<script>
export default {
  name: 'IosFrance',
};
</script>

<style scoped>
.english-container {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1, h2,h3,h4,h5 {
  color: #333;
 text-align: left; /* 明确标题左对齐（如果父级未继承） */

}
ul, ol {
  margin-left: 20px;
  padding-left: 15px;
 list-style-type: decimal; /* 强制显示数字编号 */

}
li {
  margin-bottom: 8px;
  text-align: left;
  color: #000000;
}

.image_1 {
  width: 90%; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}

</style>